import { HANDLED_SUBCODES } from '../../../EsigningProvider/types';
export const isFailedSubcodeHandled = (subcode) => subcode !== null && subcode !== undefined && HANDLED_SUBCODES.includes(subcode);
